import { Component, Input } from '@angular/core';

@Component({
    selector: 'fc-progress-spinner',
    template: `
        <div class="fc-progress-spinner-{{ position }}">
            <mat-spinner [diameter]="diameter"></mat-spinner>
        </div>
    `,
    styleUrls: ['./fc-progress-spinner.component.less'],
    standalone: false
})
export class FcProgressSpinnerComponent {
    @Input() public position: Position = 'absolute';
    @Input() public diameter = 50;
}

type Position = 'absolute' | 'none';
